import {takeLatest, put, all, call} from 'redux-saga/effects';
import {successToast} from '../actions';
import * as AC from '../actions/actionTypes';
import {
  addCustomerGarageApi,
  addGarageApi,
  deleteCustomerGarageApi,
  deleteGarageApi,
  editCustomerGarageApi,
  editGarageApi,
  getCustomerGaragesApi,
  getGarageReportApi,
  getGarageReportFiltersApi,
  getGaragesByBuildingApi,
} from '../api/garages.service';
import {errorHandler} from '../utils/errorHandler';

function* getBuildingGaragesSaga(fn) {
  try {
    const response = yield call(
      getGaragesByBuildingApi,
      fn.buildingId,
      fn.filters,
    );
    yield put({
      type: AC.GET_BUILDING_GARAGES_SUCCEED,
      payload: response.data.data,
      page: response.data.page,
      totalPages: response.data.totalPages,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_BUILDING_GARAGES_FAILED);
  }
}

function* addGarageSaga(fn) {
  try {
    const response = yield call(addGarageApi, fn.payload);
    yield put({
      type: AC.ADD_GARAGE_SUCCEED,
      payload: response.data,
      buildingId: response.data.buildingId,
      filters: {},
    });
    yield put(successToast('Garage created successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.ADD_GARAGE_FAILED);
  }
}

function* editGarageSaga(fn) {
  try {
    const response = yield call(editGarageApi, fn.payload);
    yield put({
      type: AC.EDIT_GARAGE_SUCCEED,
      payload: response.data,
      buildingId: response.data.buildingId,
      filters: {},
    });
    yield put(successToast('Garage edited successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.EDIT_GARAGE_FAILED);
  }
}

function* deleteGarageSaga(fn) {
  try {
    yield call(deleteGarageApi, fn.id);
    yield put({
      type: AC.DELETE_GARAGE_SUCCEED,
      buildingId: fn.buildingId,
      filters: {},
    });
    yield put(successToast('Garage deleted successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.DELETE_GARAGE_FAILED);
  }
}

function* getCustomerGaragesSaga(fn) {
  try {
    const response = yield call(getCustomerGaragesApi, fn.customerId);
    yield put({type: AC.GET_CUSTOMER_GARAGES_SUCCEED, payload: response.data});
  } catch (e) {
    yield errorHandler(e, AC.GET_CUSTOMER_GARAGES_FAILED);
  }
}

function* addCustomerGarageSaga(fn) {
  try {
    const response = yield call(addCustomerGarageApi, fn.payload);
    yield put({
      type: AC.ADD_CUSTOMER_GARAGE_SUCCEED,
      payload: response.data,
      customerId: fn.customerId,
    });
    yield put(successToast('Garage data added successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.ADD_CUSTOMER_GARAGE_FAILED);
  }
}

function* editCustomerGarageSaga(fn) {
  try {
    const response = yield call(editCustomerGarageApi, fn.payload);
    yield put({
      type: AC.EDIT_CUSTOMER_GARAGE_SUCCEED,
      payload: response.data,
      customerId: fn.customerId,
    });
    yield put(successToast('Garage data edited successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.EDIT_CUSTOMER_GARAGE_FAILED);
  }
}

function* deleteCustomerGarageSaga(fn) {
  try {
    yield call(deleteCustomerGarageApi, fn.id);
    yield put({
      type: AC.DELETE_CUSTOMER_GARAGE_SUCCEED,
      customerId: fn.customerId,
    });
    yield put(successToast('Garage data deleted successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.DELETE_CUSTOMER_GARAGE_FAILED);
  }
}

function* getGarageReportSaga(fn) {
  try {
    const response = yield call(getGarageReportApi, fn.filters);
    yield put({
      type: AC.GET_GARAGE_REPORT_SUCCEED,
      payload: response.data.data,
      page: response.data.page,
      totalPages: response.data.totalPages,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_GARAGE_REPORT_FAILED);
  }
}

function* getGarageReportFiltersSaga(fn) {
  try {
    const params = fn.buildingId ? {buildingId: fn.buildingId} : {};
    const response = yield call(getGarageReportFiltersApi, params);
    yield put({type: AC.GET_GARAGE_REPORT_FILTERS_SUCCEED, payload: response.data});
  } catch (e) {
    yield errorHandler(e, AC.GET_GARAGE_REPORT_FILTERS_FAILED);
  }
}

function* actionWatcher() {
  yield takeLatest(AC.GET_GARAGE_REPORT_REQUEST, getGarageReportSaga);
  yield takeLatest(
    AC.GET_GARAGE_REPORT_FILTERS_REQUEST,
    getGarageReportFiltersSaga,
  );

  // Every successful write re-fetches the list it belongs to (same pattern as entrances).
  yield takeLatest(
    [
      AC.GET_BUILDING_GARAGES_REQUEST,
      AC.ADD_GARAGE_SUCCEED,
      AC.EDIT_GARAGE_SUCCEED,
      AC.DELETE_GARAGE_SUCCEED,
    ],
    getBuildingGaragesSaga,
  );
  yield takeLatest(AC.ADD_GARAGE_REQUEST, addGarageSaga);
  yield takeLatest(AC.EDIT_GARAGE_REQUEST, editGarageSaga);
  yield takeLatest(AC.DELETE_GARAGE_REQUEST, deleteGarageSaga);

  yield takeLatest(
    [
      AC.GET_CUSTOMER_GARAGES_REQUEST,
      AC.ADD_CUSTOMER_GARAGE_SUCCEED,
      AC.EDIT_CUSTOMER_GARAGE_SUCCEED,
      AC.DELETE_CUSTOMER_GARAGE_SUCCEED,
    ],
    getCustomerGaragesSaga,
  );
  yield takeLatest(AC.ADD_CUSTOMER_GARAGE_REQUEST, addCustomerGarageSaga);
  yield takeLatest(AC.EDIT_CUSTOMER_GARAGE_REQUEST, editCustomerGarageSaga);
  yield takeLatest(AC.DELETE_CUSTOMER_GARAGE_REQUEST, deleteCustomerGarageSaga);
}

export default function* garagesSaga() {
  yield all([actionWatcher()]);
}
